import { render, staticRenderFns } from "./SumjSide.vue?vue&type=template&id=ecf20a64&scoped=true&"
import script from "./SumjSide.vue?vue&type=script&lang=js&"
export * from "./SumjSide.vue?vue&type=script&lang=js&"
import style0 from "./SumjSide.vue?vue&type=style&index=0&id=ecf20a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf20a64",
  null
  
)

export default component.exports